export default {
  name: 'evaluate-answer-call-list',
  created () {
    this.search()
  },
  data () {
    return {
      deadlineKey: null,
      nonAnswers: []
    }
  },
  computed: {
    authToken () {
      return window.localStorage.getItem('access_token')
    },
    timeStamp () {
      var d = new Date()
      var year = d.getFullYear()
      var month = d.getMonth() + 1
      var day = d.getDate()
      var hour = (d.getHours() < 10) ? '0' + d.getHours() : d.getHours()
      var min = (d.getMinutes() < 10) ? '0' + d.getMinutes() : d.getMinutes()
      var sec = (d.getSeconds() < 10) ? '0' + d.getSeconds() : d.getSeconds()
      return year + '' + month + '' + day + '' + hour + '' + min + '' + sec
    }
  },
  methods: {
    async search () {
      let data = {
        shop_id: localStorage.shop_id
      }
      let res = await this.$store.dispatch('EVALUATE_ANSWER_NOANSWER_LIST', { data: data })
      .catch(err => {
        console.log(err)
        return
      })
      this.nonAnswers = res
      if (this.nonAnswers.length) {
        this.deadlineKey = this.nonAnswers[0].evaluate_answer_user_id
      }
    },
    first: function (index) {
      if (index === 0) {
        return 'border-radius: 5px 5px 0px 0px;'
      } else {
        return ''
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/evaluate-answer-call-list.js